import { Collapse, Drawer } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { gtmEvent } from 'app/modules/gtm/service/gtm.service';
import { ContentType, PagePart } from 'app/modules/step-engine/utils/step-engine-constants';
import { IRootState } from 'app/shared/reducers';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ISpbNavbarItem } from 'spb-react-components';
import ModalInfo from '../modals/modal-info/modal-info';
import './sidebar.scss';
import moment from 'moment';
type ISideBar = {
  menuOpen: boolean;
  setMenuClose(open: boolean): void;
  didomiObject: any;
  footerLinks: any;
  sideBarContent: any;
  selectItem?: (value: ISpbNavbarItem) => void;
}

const SideBar = (props: ISideBar) => {
  const { menuOpen, setMenuClose, didomiObject, footerLinks, sideBarContent, selectItem } = props;
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();

  const cmsContent = useSelector((state: IRootState) => state.cms.cmsContent);
  const { isAuthenticated } = useSelector((state: IRootState) => state.authentication);
  const { behaviors } = cmsContent[PagePart.SIDE_BAR_MOBILE] || {};
  const { cookieManagement, headerLinkMobile } = cmsContent[PagePart.APP_GLOBAL_TYPE]?.prismic || {}
  const { smallBottomIcon } = cmsContent[PagePart.GENERIC_SIDE_NAV_PDV]?.prismic || {}
  const {
    exitText,
    exitTextAfterDeclaration,
    exitCancelButton,
    exitValidButton
  } = cmsContent[PagePart.POP_IN]?.prismic || {}
  const { claimNumber } = useSelector((state: IRootState) => state.claim);

  const handleLogOut = () => {
    setModal(true);
    if (!modal) {
      setMenuClose(!modal)
    }
  }

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleDrawerClose = () => {
    setMenuClose(!menuOpen)
  }

  const manageCookies = () => {
    if (didomiObject) {
      didomiObject.preferences.show();
    }
  };

  const openDocument = (item: any, otherTab = true) => {

    if (otherTab) {
      dispatch(gtmEvent(item.label, 'Consultation', '0'));
      window.open(item.url, '_blank', 'noopener,noreferrer')
    }
    else {
      if (selectItem) selectItem(item);
    }
  }

  const getLink = (contentType: ContentType) => {
    const item = footerLinks[contentType];
    return (
      <p style={{ marginLeft: "1rem" }} onClick={() => { openDocument(item) }}> <img />{item.label}</p>
    )
  }

  const legalInfos = (item: any) => {

    return (
      <>
        <p onClick={handleClick} >
          <img />
          {headerLinkMobile}
          {open ? <ExpandLess /> : <ExpandMore />}
        </p>
        <Collapse in={open} timeout="auto" unmountOnExit>
          {footerLinks && !behaviors?.items.includes('2') && getLink(ContentType.LEGAL_NOTICE)}
          {footerLinks && !behaviors?.items.includes('4') && getLink(ContentType.PRIVACY_POLICY)}
          {footerLinks && !behaviors?.items.includes('3') && getLink(ContentType.TERMS_OF_SERVICE)}
        </Collapse>
      </>
    );
  };

  const disconnectDesktop = () => {
    window.location.href = "/logout"
  }

  const closeModalLogOutDesktop = () => {
    setOpen(false);
  }

  return (
    <>
      <Drawer
        anchor={'left'}
        open={props.menuOpen}
        onClose={handleDrawerClose}
      >
        <div className="menu-spb">
          <div className="list-menu">
            {sideBarContent?.map((item, index) => {
              return <p key={index} onClick={() => openDocument(item, false)}> <img src={item?.icon} />{item.label}</p>
            })}
            {legalInfos(sideBarContent?.items)}
            {!behaviors?.items.includes('5') && <p onClick={manageCookies}> <img />{cookieManagement}</p>}
            {isAuthenticated && !behaviors?.items.includes('6') && <p onClick={handleLogOut}> <img src="/content/images/mobile-view/navBar/disconnect.svg" alt="home" /> D&eacute;connexion</p>}
          </div>
          <div className='menu-spb-footer'>
            <div className='footer-logo'>
              <img className='footer-img' src={smallBottomIcon} alt="logo" />
            </div>
            <div className="spb-footer-version">Copyright © {moment().format('YYYY')} version : {process.env.REACT_APP_VERSION.replace('-SNAPSHOT', '')}</div>
          </div>
        </div>
      </Drawer >
      <ModalInfo
        modal={modal}
        setModal={setModal}
        handleOk={disconnectDesktop}
        handleCancel={closeModalLogOutDesktop}
        message={claimNumber ? [exitTextAfterDeclaration] : [exitText]}
        txtValidButton={exitValidButton}
        txtCancelButton={exitCancelButton}
      />
    </>
  );
};

export default SideBar;


